import axios from "axios";
import { API_BASE_URL } from "./apiUrl";
import { API_URL } from "./apiUrl";
import { jwtDecode } from "jwt-decode";
// import { useNavigate } from "react-router-dom";

// GET request
// export const fetchData = async (endpoint) => {
//   try {
//     let token = localStorage.getItem('user_token')

//     const response = await fetch(`${API_URL}/${endpoint}`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//     });

//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response.json();
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// export const fetchDataAuth = async (endpoint) => {
//   try {
//     let token = localStorage.getItem('user_token')

//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//     });

//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// export const fetchToken = async (identity, roomName) => {
//   try {
//     console.log(">>>>>>>>>identity ", identity, roomName)
//     const response = await fetch(`http://localhost:8081/api/auth/generateToken?identity=${identity}&roomName=${roomName}`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         // 'Authorization': `Bearer ${token}`
//       },
//     });

//     console.log("response 111 >>>>>>>>", response)

//     console.log("response 222 >>>>>>>>", response.json())

//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     const data = response.json();
//     console.log("response data >>>>>>>>", data);
//     return await data;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// POST request with token
// export const postData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//       body: JSON.stringify(body),
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// POST request with token
// export const updateData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'PATCH',
//       headers: {
//         'Authorization': `Bearer ${token}`
//       },
//       body: body,
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// export const putData = async (endpoint, body) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'PUT',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       },
//       body: body,
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// export const deleteData = async (endpoint) => {
//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'DELETE',
//       headers: {
//         'Authorization': `Bearer ${token}`
//       }
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// POST request without token
// export const postRequest = async (endpoint, body) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(body),
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

// export const fetchDataAxiosPost = async (endpoint, body) => {
//   try {
//     const api = axios.create({
//       baseURL: API_BASE_URL,
//       headers: {
//         "Content-Type": "application/json"
//       },
//       withCredentials: true
//     });
//     const response = await api.post(`${endpoint}`, body);
//     console.log('Response headers:', response);
//     return await response;
//   } catch (error) {
//     console.error('Error fetching data:', error);
//     return "Bad Request"
//   }
// };

export const fetchDataAxiosPost = async (endpoint, body, config = {}) => {
  try {
    const response = await api.post(endpoint, body, config);
    return response;
  } catch (error) {
    // console.error(" Error fetching data:", error);
    throw error;
  }
};


export const fetchAxiosPostData = async (endpoint, body, config = {}) => {
  try {
    const response = await apiUrl.post(endpoint, body, config);
    return response;
  } catch (error) {
    // console.error(" Error fetching data:", error);
    throw error;
  }
};

export const updateData = async (endpoint, body) => {
  try {
    const response = await api.put(`${endpoint}`, body);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateUserData = async (body) => {
  try {
    const response = await api.put(`/user/update`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBenDataWithHeader = async (endpoint, body, userEmail) => {
  try {
    const response = await api.put(`${endpoint}`, body, {
      headers: {
        userEmail: userEmail,
      },
    });
    return response;
  } catch (error) {
    // console.error("Error updating data:", error);
    throw error;
  }
};

export const updateSurveyData = async (endpoint, body, userEmail) => {
  try {
    const response = await api.put(`${endpoint}`, body, {
      headers: {
        userEmail: userEmail,
      },
    });
    return response;
  } catch (error) {
    // console.error("Error updating data:", error);
    throw error;
  }
};

export const deleteData = async (endpoint) => {
  try {
    const response = await api.delete(`${endpoint}`);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const deleteUserListData = async (endpoint, userRole, userEmail) => {
  try {
    const response = await api.delete(`${endpoint}`, {
      headers: {
        adminEmail: userEmail || "",
        userEmail: userRole || "",
      },
    });
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchDataAxios = async (endpoint) => {
  try {
    const response = await api.get(`${endpoint}`);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchDataAxiosAPM = async (endpoint) => {
  try {
    const response = await api1.get(`${endpoint}`);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchDataAxiosAPMWithHeaders = async (endpoint, customHeaders = {}) => {
  try {
    const response = await api1.get(`${endpoint}`, { 
      headers: { ...customHeaders }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchDataWithHeader = async (endpoint, userEmail) => {
  try {
    const response = await api.get(endpoint, {
      headers: { userEmail },
    });

    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchDataWithParam = async (endpoint, paramValue) => {
  try {
    let paramValueData = paramValue ? paramValue.trim() : "";
    const response = await api.get(`${endpoint}${paramValueData}`);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchUserListParam = async (endpoint, userRole, userEmail) => {
  try {
    const response = await api.get(endpoint, {
      headers: {
        userEmail: userEmail || "",
        userRole: userRole || "",
      },
    });

    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

//   let token = localStorage.getItem('user_token')
//   try {
//     const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
//       method: 'PATCH',
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(body),
//     });
//     if (!response.ok) {
//       const errorDetails = await response.json();
//       const errorMessages = Object.values(errorDetails).flat();
//       throw new Error(errorMessages[0]);
//     }
//     return await response;
//   } catch (error) {
//     console.error('API Error:', error);
//     throw error;
//   }
// };

export const registerAdmin = async (endpoint, body) => {
  try {
    const response = await api.post(`${endpoint}`, body);
    return response;
  } catch (error) {
    // console.error(
    //   " Registration Failed:",
    //   error.response?.data || error.message
    // );
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    const response = await api.post(
      "/auth/logout",
      {},
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    console.error("Logout Failed:", error.response?.data || error.message);
    throw error;
  }
};

export const logoutUserRedirect = () => {
  localStorage.clear();
  window.location.href = "/login"; // Redirect to login
};

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const api1 = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

api1.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token"); // <-- Token yahan lo

  const userEmail = localStorage.getItem("userEmail")?.trim() || "";
  const userRole = localStorage.getItem("userRole")?.trim() || "";

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Only set default headers if custom headers aren't provided
  if (!config.headers.useremail) {
    config.headers.userEmail = userEmail;
  }
  
  if (!config.headers.role) {
    config.headers.userRole = userRole;
  }

  return config;
});

// export const api1 = axios.create({
//   baseURL: API_BASE_URL,
//   withCredentials: true,
//   headers: {
//     "Content-Type": "application/json",
//     userEmail: userEmail || "",
//     userRole: userRole || "",
//   },
// });

export const apiUrl = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const uploadFile = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadFileApi.post(endpoint, body, config);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

// export const uploadFile = async (endpoint, body, config = {}) => {
//   const token = localStorage.getItem('access_token');
//   const headers = {
//     "Content-Type": "multipart/form-data",
//     "Authorization": `Bearer ${token}`,
//     ...config.headers,
//   };

//   try {
//     const response = await uploadFileApi.post(endpoint, body, { ...config, headers });
//     return response;
//   } catch (error) {
//     console.error("Error uploading file:", error);
//     throw error;
//   }
// };

export const updateMilestone = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadDataApi.put(endpoint, body);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const uploadData = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadDataApi.post(endpoint, body, config);
    // console.log(" Response Headers:", response?.headers);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateFile = async (endpoint, body, config = {}) => {
  try {
    const response = await uploadFileApi.put(endpoint, body, config);
    // console.log(" Response Headers:", response?.headers);
    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

export const uploadFileApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// uploadFileApi.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("access_token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

uploadFileApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    const userEmail = localStorage.getItem("userEmail")?.trim() || ""; // ✅ added

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["userEmail"] = userEmail; // ✅ added — matches backend @RequestHeader("userEmail")

    return config;
  },
  (error) => Promise.reject(error)
);

export const uploadSurveyAttachment = async (programId, file, fieldType) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fieldType", fieldType);
  return uploadFileApi.post(`/surveyData/files/${programId}`, formData);
};

export const uploadSubSurveyAttachment = async (programId, subSurveyId, file, fieldType) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fieldType", fieldType);
  return uploadFileApi.post(`/subSurveyData/files/${programId}/${subSurveyId}`, formData);
};

export const leaseSurveyAttachments = async (programId, blobNames) => {
  return api.post(`/surveyData/files/${programId}/lease`, { blobNames });
};

export const leaseSubSurveyAttachments = async (programId, subSurveyId, blobNames) => {
  return api.post(`/subSurveyData/files/${programId}/${subSurveyId}/lease`, { blobNames });
};

export const uploadDataApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

uploadDataApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      const token1 = refreshToken();
      config.headers["Authorization"] = `Bearer ${token1}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const downloadFileApi = axios.create({
  baseURL: API_BASE_URL,
  // withCredentials: true,
  headers: {
    "Content-Type":
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
});

export const downloadFile = async (endpoint) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
      responseType: "blob",
      // withCredentials: true,
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    // console.error("Error fetching file", error);
    throw error;
  }
};

// // Request Interceptor: Attach Access Token to Every Request
api.interceptors.request.use(
  async (config) => {
    if (config.url?.includes("/auth/logout")) {
      let userEmail = localStorage.getItem("userEmail");
      config.headers.userEmail = userEmail;
      return config;
    }
    let token = localStorage.getItem("access_token");

    if (token) {
      const decodedToken = jwtDecode(token);
      const isTokenExpired = decodedToken.exp * 1000 < Date.now();

      if (isTokenExpired) {
        token = await refreshToken();

        if (!token) {
          localStorage.clear();
          logoutUserRedirect();

          return Promise.reject("Unauthorized");
        }
      }

      // config.headers.authorization = `${token}`;
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor: Handle Unauthorized Errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      if (error.config.url.includes("/refresh-token")) {
        logoutUserRedirect();
        return Promise.reject(error);
      }

      const newToken = await refreshToken();

      if (newToken) {
        error.config.headers["Authorization"] = `Bearer ${newToken}`;
        return api.request(error.config);
      }
      logoutUserRedirect();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

// Function to Refresh Token
export const refreshToken = async () => {
  try {
    const response = await axios.post(
      API_BASE_URL + "/auth/refresh-token",
      {},
      { withCredentials: true }
    );

    if (response.status === 200) {
      const newAccessToken = response.headers["authorization"]; // Extract new token
      if (!newAccessToken) {
        logoutUserRedirect();
        return null;
      }
      localStorage.setItem("access_token", newAccessToken);
      return newAccessToken;
    } else {
      logoutUserRedirect();
      return null;
    }
  } catch (error) {
    // console.error("🔴 Refresh Token failed. Logging out...");
    if (error.response && error.response.status === 401) {
      return null;
    }
    logoutUserRedirect();
    return null;
  }
};

export const fetchUserListPage = async (
  endpoint,
  userRole,
  userEmail,
  payload = {}
) => {
  try {
    const response = await api.post(endpoint, payload, {
      headers: {
        userEmail: userEmail || "",
        userRole: userRole || "",
      },
    });

    return response;
  } catch (error) {
    // console.error("Error fetching data:", error);
    throw error;
  }
};

// const refreshToken = async () => {
//   try {
//     const response = await axios.post(
//       `${API_BASE_URL}/auth/refresh-token`,
//       {},
//       { withCredentials: true }
//     );

//     if (response.status === 204) { // Backend returns 204 No Content with headers
//       const newAccessToken = response.headers["authorization"];
//       if (newAccessToken) {
//         localStorage.setItem("access_token", newAccessToken);
//         return newAccessToken;
//       } else {
//         console.warn(" No new access token received during refresh.");
//         logoutUserRedirect();
//         return null;
//       }
//     } else {
//       console.warn(` Refresh Token request failed with status: ${response.status}`);
//       logoutUserRedirect();
//       return null;
//     }
//   } catch (error) {
//     console.error(" Error during refresh token request:", error);
//     logoutUserRedirect();
//     return null;
//   }
// };

// api.interceptors.request.use(
//   async (config) => {
//     const token = localStorage.getItem("access_token");
//     if (token) {
//       try {
//         const decodedToken = jwtDecode(token);
//         const isTokenExpired = decodedToken.exp * 1000 < Date.now();

//         if (isTokenExpired) {
//           const newToken = await refreshToken();
//           if (newToken) {
//             config.headers["Authorization"] = `Bearer ${newToken}`;
//           } else {
//             return Promise.reject("Unauthorized - Refresh failed");
//           }
//         } else {
//           config.headers["Authorization"] = `Bearer ${token}`;
//         }
//       } catch (error) {
//         console.error(" Error decoding token:", error);
//         localStorage.removeItem("access_token"); // Token might be invalid, clear it
//         // Optionally redirect to login here if you suspect a corrupted token
//       }
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response?.status === 401) {
//       if (error.config.url.includes("/refresh-token")) {
//         logoutUserRedirect();
//         return Promise.reject(error);
//       }

//       const originalRequest = error.config;
//       const newToken = await refreshToken();

//       if (newToken) {
//         originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//         return api.request(originalRequest); // Retry the original request
//       } else {
//         logoutUserRedirect();
//         return Promise.reject(error);
//       }
//     }
//     return Promise.reject(error);
//   }
// );
